import { StyleSheet } from "aphrodite";

/** Shared responsive styles for list page headers. */
export const listHeaderStyles = StyleSheet.create({
  bar: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    width: "100%",
    boxSizing: "border-box",
    padding: "16px 20px 20px",
    backgroundColor: "#F8F9FB",
    position: "relative",
    zIndex: 20,
    overflow: "visible",
    "@media (max-width: 768px)": {
      flexDirection: "column",
      alignItems: "stretch",
      padding: "12px 12px 16px",
      gap: 10,
    },
  },
  title: {
    flex: "1 1 200px",
    minWidth: 0,
    margin: 0,
    "@media (max-width: 768px)": {
      flex: "1 1 100%",
      width: "100%",
    },
  },
  titleText: {
    margin: "8px 0",
    fontSize: 20,
    lineHeight: "28px",
    wordBreak: "break-word",
    "@media (max-width: 768px)": {
      fontSize: 16,
      lineHeight: "22px",
      margin: "4px 0 8px",
    },
  },
  actions: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: 10,
    flex: "1 1 280px",
    minWidth: 0,
    "@media (max-width: 768px)": {
      flex: "1 1 100%",
      width: "100%",
      justifyContent: "stretch",
      flexDirection: "column",
      alignItems: "stretch",
    },
  },
  field: {
    width: 200,
    minWidth: 0,
    flex: "0 1 200px",
    "@media (max-width: 768px)": {
      width: "100%",
      flex: "1 1 100%",
      maxWidth: "100%",
    },
  },
  fieldNarrow: {
    width: 150,
    minWidth: 0,
    flex: "0 1 150px",
    "@media (max-width: 768px)": {
      width: "100%",
      flex: "1 1 100%",
      maxWidth: "100%",
    },
  },
  buttonFull: {
    whiteSpace: "nowrap",
    "@media (max-width: 768px)": {
      width: "100% !important",
      maxWidth: "100%",
    },
  },
  filterButton: {
    backgroundColor: "#F0F3F6",
    borderRadius: 5,
    color: "#4F5867",
    borderColor: "#F0F3F6",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    whiteSpace: "nowrap",
    width: "auto",
    "@media (max-width: 768px)": {
      width: "100%",
      minHeight: 40,
    },
  },
  tableScroll: {
    width: "100%",
    overflowX: "auto",
    WebkitOverflowScrolling: "touch",
  },
});
